import memoizeOne from 'memoize-one';
import { componentsEvaluateFormatRule } from '../field-types/components/evaluate-format-rule/index.tsx';
import { dateEvaluateFormatRule } from '../field-types/date/evaluate-format-rule/index.tsx';
import { labelsEvaluateFormatRule } from '../field-types/labels/evaluate-format-rule/index.tsx';
import { multiSelectEvaluateFormatRule } from '../field-types/multi-select/evaluate-format-rule/index.tsx';
import { numberEvaluateFormatRule } from '../field-types/number/evaluate-format-rule/index.tsx';
import { priorityEvaluateFormatRule } from '../field-types/priority/evaluate-format-rule/index.tsx';
import { projectEvaluateFormatRule } from '../field-types/project/evaluate-format-rule/index.tsx';
import { radioEvaluateFormatRule } from '../field-types/radio-select/evaluate-format-rule/index.tsx';
import { singleSelectEvaluateFormatRule } from '../field-types/single-select/evaluate-format-rule/index.tsx';
import { sprintEvaluateFormatRule } from '../field-types/sprint/evaluate-format-rule/index.tsx';
import { statusEvaluateFormatRule } from '../field-types/status/evaluate-format-rule/index.tsx';
import { textEvaluateFormatRule } from '../field-types/text/evaluate-format-rule/index.tsx';
import { typeEvaluateFormatRule } from '../field-types/type/evaluate-format-rule/index.tsx';
import { userEvaluateFormatRule } from '../field-types/user/evaluate-format-rule/index.tsx';
import { versionEvaluateFormatRule } from '../field-types/version/evaluate-format-rule/index.tsx';
import type { ListIssueFieldTransformedForFormatRule } from '../types.tsx';
import type { FormatRule } from './types.tsx';

export const createFormatRuleHandlers = memoizeOne(() => ({
	...textEvaluateFormatRule,
	...labelsEvaluateFormatRule,
	...userEvaluateFormatRule,
	...dateEvaluateFormatRule,
	...numberEvaluateFormatRule,
	...priorityEvaluateFormatRule,
	...projectEvaluateFormatRule,
	...sprintEvaluateFormatRule,
	...versionEvaluateFormatRule,
	...typeEvaluateFormatRule,
	...statusEvaluateFormatRule,
	...singleSelectEvaluateFormatRule,
	...multiSelectEvaluateFormatRule,
	...radioEvaluateFormatRule,
	...componentsEvaluateFormatRule,
}));

export const evaluateFormatRule = (
	fieldType: keyof ReturnType<typeof createFormatRuleHandlers>,
	...args: Parameters<FormatRule<ListIssueFieldTransformedForFormatRule>>
) => {
	const handlers = createFormatRuleHandlers();

	if (handlers[fieldType] == null) {
		return;
	}
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	return (handlers[fieldType] as FormatRule<ListIssueFieldTransformedForFormatRule>)?.(...args);
};

export const isFormatRuleEvaluationSupported = (
	fieldType?: string,
): fieldType is keyof ReturnType<typeof createFormatRuleHandlers> => {
	if (!fieldType) return false;
	const handlers = createFormatRuleHandlers();
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	return handlers[fieldType as keyof ReturnType<typeof createFormatRuleHandlers>] != null;
};
